/**
 *  When Enter key is hit on decorated element, click event is triggered on element(s) matching given selector
 *
 *  Example:
 *
 *  <input type="text" data-click-on-enter="#myButton" />
 *  <button id="myButton" type="submit">Submit</button>
 *
 *  When hitting enter key while focus is on input element, click event of myButton element is triggered.
 */

export default function () {
    $('[data-click-on-enter]', this).on('keyup', function (e) {
        if(e.keyCode === 13) {
            const target = $(this).attr('data-click-on-enter');
            $(target).trigger('click');
            return false;
        }
    });
}


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/initializers/clickOnEnter.js